// extracted by mini-css-extract-plugin
export var desktop = "map2-module--desktop--2lMRQ";
export var mobile = "map2-module--mobile--1WLjy";
export var map = "map2-module--map--2W9gG";
export var section = "map2-module--section--OkwD4";
export var sectionResponsive = "map2-module--section-responsive--HVvhI";
export var column = "map2-module--column--1EB82";
export var image = "map2-module--image--mX6cN";